"use strict";
exports.__esModule = true;
var resolve_url_1 = require("./resolve-url");
exports.containsProtocolDelimeter = function (value) { return value.indexOf('://') > -1; };
exports.isValidProtocol = function (protocol, httpsRequired) {
    if (httpsRequired === void 0) { httpsRequired = false; }
    return Boolean(protocol.match(httpsRequired ? /^https:$/ : /^https?:$/));
};
exports.isPattern = function (value) { return value.indexOf('*') > -1; };
exports.addProtocol = function (value) { return "http://" + value; };
exports.getDomain = function (value) {
    var URL = resolve_url_1["default"]();
    try {
        var hostname = new URL(value).hostname;
        if (!hostname) {
            return '';
        }
        var parts = hostname.split('.');
        var tld = parts.pop();
        var sld = parts.pop();
        if (sld === 'com' || tld === 'il') {
            tld = sld + "." + tld;
            sld = parts.pop();
        }
        if (tld && !sld) {
            return tld;
        }
        return sld + "." + tld;
    }
    catch (err) {
        return '';
    }
};
